import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
  const options = {
    params: params,
    paramsSerializer: function (params) {
      return qs.stringify(params, {encode: false});
    }
  };

  return axios.get(`${url}/precios`, options)
    .then(response => {
      return {
        list: jsona.deserialize(response.data),
        meta: response.data.meta
      };
    });
}

function get(id) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'Content-Type': 'application/vnd.api+json',
    }
  };

  return axios.get(`${url}/precios/${id}`, options)
    .then(response => {
      let precio = jsona.deserialize(response.data);
      delete precio.links;
      return precio;
    });
}

function add(archivo) {
  const options = {
    headers: {
      'Accept': 'application/vnd.api+json',
      'content-type': 'multipart/form-data',
    }
  };

  return axios.post(`${url}/precios`, archivo, options)
    .then(response => {
      return jsona.deserialize(response.data);
    });
}

function exportar(){
  const options = {
    headers: {
      'Accept': '*/*',
      'Content-Type': 'application/vnd.api+json',
    },
    responseType: 'blob',
  };

  return axios.get(`${url}/exportarPrecios`, options)
    .then(response => {
      let fileName = "precios.xlsx";
      if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE variant
          window.navigator.msSaveOrOpenBlob(new Blob([response.data],
                  { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }
              ),
              fileName
          );
      } else {
          const url = window.URL.createObjectURL(new Blob([response.data],
              { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' }));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download',
              fileName);
          document.body.appendChild(link);
          link.click();
      }
    })
    .catch((error) => {
      console.log(error)
    })
}

export default {
  list,
  get,
  add,
  exportar
};

